<div class="row row--options">
  <div class="col-md-3">
    <button
      pButton
      [size]="client() ? 'small' : undefined"
      [severity]="client() ? 'success' : undefined"
      (click)="addNewClick()"
    >
      <i class="pi pi-plus"></i> Add new quote
    </button>
  </div>
</div>

<!-- Rendered by the quote list after its table: the bar is sticky, and a sticky
     element cannot leave its parent's box. -->
<ng-template #selectionBar>
  <app-table-selection-bar
    [selectedCount]="selectedQuotes().length"
    [totalCount]="totalCount()"
    (selectAll)="selectAll.emit()"
    (clearSelection)="emitClearSelection()"
  >
    @if (!isBatchEmailDisabled()) {
      <button
        pButton
        severity="primary"
        variant="text"
        size="small"
        (click)="toggleEditor.emit()"
      >
        <i class="pi pi-send"></i> Batch send
      </button>
    }
    @if (!isBatchReplicateDisabled()) {
      <button
        pButton
        data-cy="quote-replicate"
        severity="primary"
        variant="text"
        size="small"
        (click)="batchReplicate()"
      >
        <i class="pi pi-clone"></i> Replicate
      </button>
    }
    @if (!isBatchDeleteDisabled()) {
      <button
        pButton
        data-cy="quote-batch-delete"
        severity="danger"
        variant="text"
        size="small"
        (click)="batchDelete()"
      >
        <i class="pi pi-trash"></i> Delete
      </button>
    }
    @if (!isBatchAcceptDisabled()) {
      <button
        pButton
        data-cy="quote-batch-delete"
        severity="primary"
        variant="text"
        size="small"
        (click)="batchAccept()"
      >
        <i class="pi pi-check"></i> Accept
      </button>
    }
    @if (!isBatchDeclineDisabled()) {
      <button
        pButton
        data-cy="quote-batch-delete"
        severity="primary"
        variant="text"
        size="small"
        (click)="declineFormVisible = true"
      >
        <i class="pi pi-times"></i> Decline
      </button>
    }
  </app-table-selection-bar>
</ng-template>

@if (declineFormVisible) {
  <app-quote-decline-form
    (closeView)="declineFormVisible = false"
    (declineQuote)="batchDecline($event); declineFormVisible = false"
  >
  </app-quote-decline-form>
}
